import { render, staticRenderFns } from "./main-demo.vue?vue&type=template&id=6a70a652&"
import script from "./main-demo.vue?vue&type=script&lang=ts&"
export * from "./main-demo.vue?vue&type=script&lang=ts&"
import style0 from "./main-demo.vue?vue&type=style&index=0&id=6a70a652&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports